import { Card, Text, styled } from '@/theme/index';

export const CardContainer = styled(Card)(() => ({
  height: '100%',
  minHeight: '175px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.5)',
  border: 'none',
  padding: '20px',
}));

export const CardCityStateZipContainer = styled(Text)(({ theme }) => ({
  margin: '0 0 12px',
  fontWeight: 'normal',
  color: theme.palette.text.secondary,

  [theme.breakpoints.up('sm')]: {
    width: '100%',
    marginBottom: '12px',
  },
}));
